module.exports = __webpack_public_path__ + "img/mateuszinsta.478dfbe3.jpg";